<template>
  <div :id="id">
    <div class="row">
      <div
        class="col-lg-4 col-md-6 col-sm-12"
        v-for="staffmember in staff"
        :key="staffmember.Id"
      >
        <card
          header-tag="header"
          class="m-2 card-user"
        >
          <div
            class="image"
            style="
              background-color: #252b30;
              border-radius: 12px 12px 0 0;
              height: 108px;"
          >
            <h5 class="mb-0 text-center text-danger">
              {{ staffmember.Position }}
            </h5>
          </div>
          <div class="card-body">
            <div class="author">
              <a
                href="#"
                style="cursor: default"
              >
                <img
                  class="avatar border-gray"
                  v-if="staffmember.PictureUrl"
                  :src="staffmember.PictureUrl"
                  :title="staffmember.FullName"
                >
                <img
                  class="avatar border-gray"
                  v-else
                  src="@/assets/img/image-not-available.png"
                  :title="staffmember.FullName"
                >
              </a>
              <div class="h6 text-primary">
                {{ staffmember.FullName }}
              </div>
              <div>
                {{
                  staffmember.Bio
                    ? staffmember.Bio
                    : "This person is awesome, but has not provided a Bio yet!"
                }}
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StaffBiosComponent',
  props: {
    staff: {
      type: Array,
      default: function () {
        return []
      }
    },
    id: {
      type: String,
      default: ''
    },
    showPrint: {
      type: Boolean,
      default: undefined
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width: 100px;
  height: 125px;
}
.pointer {
  cursor: pointer;
}
.card .bigavatar {
  width: 140px;
  height: 140px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
</style>
